import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EventFilterService {

 getDefaultFilter() {
  return {
    authorIds: [] as number[],
    searchAuthor: undefined as string | undefined,
    searchTitle: '',
    searchLocation: '',
    searchStatus: [] as string[],
    searchCategory: [] as string[],
    searchOperatingTime: [] as string[],
    searchTaskType: [] as string[],
    searchOnline: undefined as boolean | undefined,
    searchStartTime: undefined as Date | undefined,
    searchEndTime: undefined as Date | undefined,
    minDuration: 1,
    maxDuration: 15,
  };
}

  filterTasks(tasks: any[], filter: any): any[] {
    const {
      searchTitle = '',
      searchLocation = '',
      searchStatus = [],
      searchCategory = [],
      searchOperatingTime = [],
      searchTaskType = [],
      searchOnline,
      searchStartTime,
      searchEndTime,
      minDuration = 1,
      maxDuration = 15,
    } = filter;

    const title = searchTitle.trim().toLowerCase();
    const location = searchLocation.trim().toLowerCase();

    return tasks.filter(task => {
      const matchesTitle = title ? task.title.toLowerCase().includes(title) : true;
      const matchesLocation = location ? task.location.toLowerCase().includes(location) : true;
      const matchesStatus = searchStatus.length ? searchStatus.includes(task.status) : true;
      const matchesCategory = searchCategory.length ? searchCategory.includes(task.category) : true;
      const matchesOperatingTime = searchOperatingTime.length ? searchOperatingTime.includes(task.einsatzzeit) : true;
      const matchesTaskType = searchTaskType.length ? searchTaskType.includes(task.type) : true;
      const matchesOnline = searchOnline !== undefined ? task.online === (searchOnline ? 1 : 0) : true;

      const taskStart = new Date(task.start);
      const taskEnd = new Date(task.end);
      const durationInHours = Math.ceil((taskEnd.getTime() - taskStart.getTime()) / (1000 * 60 * 60));
      const matchesDuration = durationInHours >= minDuration && durationInHours <= maxDuration;

      const matchesStartTime = searchStartTime ? taskStart >= searchStartTime : true;
      const matchesEndTime = searchEndTime ? taskEnd <= searchEndTime : true;

      return (
        matchesTitle &&
        matchesLocation &&
        matchesStatus &&
        matchesCategory &&
        matchesOperatingTime &&
        matchesTaskType &&
        matchesOnline &&
        matchesStartTime &&
        matchesEndTime &&
        matchesDuration
      );
    });
  }
}
